import { render } from "./leadercanjiandanwei.vue?vue&type=template&id=20181020&scoped=true&ts=true"
import script from "./leadercanjiandanwei.vue?vue&type=script&lang=ts"
export * from "./leadercanjiandanwei.vue?vue&type=script&lang=ts"

import "./leadercanjiandanwei.vue?vue&type=style&index=0&id=20181020&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20181020"]])

export default __exports__